import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { agent } from "../../utils/agent";
import * as API from "../../utils/apiPath";

// Maintenance component to display when site is in maintenance mode

const Maintenance = ({ message }) => (
    <div style={styles.container}>
        <div style={styles.iconWrapper}>
            <img
                src="https://cdn-icons-png.flaticon.com/512/189/189792.png"
                alt="Settings Icon"
                style={styles.icon}
            />
        </div>
        <h1 style={styles.heading}>Site Under Maintenance</h1>
        <p style={styles.message}>
            {message || 'We are currently performing maintenance. Please check back later.'}
        </p>
    </div>
);

const styles = {
    container: {
        textAlign: 'center',
        padding: '60px 20px',
        backgroundColor: '#f8f9fa',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    iconWrapper: {
        marginBottom: '20px',
    },
    icon: {
        width: '80px',
        height: '80px',
        animation: 'spin 5s linear infinite',
    },
    heading: {
        fontSize: '28px',
        color: '#333',
        marginBottom: '12px',
    },
    message: {
        fontSize: '16px',
        color: '#666',
        maxWidth: '500px',
    },
};

// HOC to check maintenance mode
const withMaintenanceCheck = (WrappedComponent) => {
    const MaintenanceCheck = (props) => {
        const [settings, setSettings] = useState({
            site_maintenance_mode: false,
            site_maintenance_message: '',
        });

        useEffect(() => {
            const url = API.GET_MAINTAINENCE_SETTING;
            console.log("URLLLL", url)
            agent
                .get(API.GET_MAINTAINENCE_SETTING)
                .then((response) => {
                    const data = response.data?.data || {};
                    console.warn('data in setting api:', data);
                    setSettings({
                        start_date_time: data.start_date_time,
                        end_date_time: data.end_date_time,
                        notification_message: data.notification_message,
                        site_maintenance_mode: data.site_maintenance_mode,
                        site_maintenance_message: data.site_maintenance_message,
                        site_maintenance_notification: data.site_maintenance_notification,
                    });
                })
                .catch((error) => {
                    console.error('Error fetching settings:', error);
                });
        }, []);

        return settings.site_maintenance_mode ? (
            <Maintenance message={settings.site_maintenance_message} />
        ) : (
            <WrappedComponent {...props} />
        );
    };

    // Set display name for better debugging in React 17
    MaintenanceCheck.displayName = `withMaintenanceCheck(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

    return MaintenanceCheck;
};

export default withMaintenanceCheck;